export default __webpack_public_path__ + "static/media/template-hero.6a245be7.jpg";